/*
  Barra de progresso de leitura da página.

  A conta é a mesma da referência — quanto já rolou dividido pelo total rolável.
  O que muda é COMO ela é chamada:

  - listener passivo, para o scroll nunca esperar por este código;
  - uma escrita por quadro no máximo (requestAnimationFrame), em vez de uma por
    evento de scroll;
  - só escreve quando o número inteiro muda, evitando recalcular layout à toa.

  A altura rolável é lida a cada quadro em vez de ficar em cache: numa página
  com conteúdo que carrega depois (imagens preguiçosas, seções de app), um
  valor guardado deixaria a barra chegando a 100% cedo demais.
*/
if (!customElements.get('page-scroll-progress')) {
  customElements.define(
    'page-scroll-progress',
    class PageScrollProgress extends HTMLElement {
      connectedCallback() {
        this.fill = this.querySelector('[data-progress-fill]');
        if (!this.fill) return;

        this.percent = -1;
        this.onScroll = this.schedule.bind(this);
        this.onVisibility = this.resync.bind(this);

        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        document.addEventListener('visibilitychange', this.onVisibility);
        this.update();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVisibility);
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      /*
        Em aba escondida o navegador não roda requestAnimationFrame. O quadro
        agendado no último scroll fica pendente e, como schedule() sai cedo
        enquanto houver um pendente, a barra congelaria no valor antigo. Ninguém
        vê isso — mas ela precisa estar certa no instante em que a aba volta.
      */
      resync() {
        if (document.visibilityState !== 'visible') return;
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.update();
      }

      schedule() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        const root = document.documentElement;
        const scrolled = window.scrollY || root.scrollTop;
        const scrollable = root.scrollHeight - root.clientHeight;
        const percent = scrollable > 0 ? Math.round((scrolled / scrollable) * 100) : 0;

        if (percent === this.percent) return;
        this.percent = percent;
        this.fill.style.width = `${percent}%`;
      }
    }
  );
}
